import React, { ComponentType } from "react";
import { IconSB } from "@/app/components/storybook/Icon/IconSB";
import IconProps from "@/app/interfaces/props/IconProps";
import { ColorTokensEnum } from "@/enums/tokens/colorTokensEnum";
import { SizeTokensEnum } from "@/enums/tokens/sizeTokensEnum";
import { CommonHelper } from "../../../../stories/helpers/CommonHelper";

const iconMap: Record<string, ComponentType<any>> = CommonHelper.getFlattenedIcons(false);
const iconNames = CommonHelper.getSortedIconNames();

interface IconBuilderProps extends Omit<IconProps, "iconInstance"> {
  icon?: string;
}

const Icon: React.FC<IconBuilderProps> = ({
  size = SizeTokensEnum.M,
  notification = false,
  color = ColorTokensEnum.DARK_GREY,
  icon,
}) => {
  const ResolvedIcon = icon ? iconMap[icon] : undefined;

  return (
    <IconSB
      size={size}
      notification={notification}
      color={color}
      iconInstance={ResolvedIcon ? <ResolvedIcon /> : undefined}
    />
  );
};

export default Icon;

export const iconRegistration = {
  name: "Icon",
  inputs: [
    {
      name: "icon",
      type: "string",
      enum: iconNames,
    },
    {
      name: "size",
      type: "string",
      enum: Object.values(SizeTokensEnum),
      defaultValue: SizeTokensEnum.M,
    },
    {
      name: "color",
      type: "string",
      enum: Object.values(ColorTokensEnum),
      defaultValue: ColorTokensEnum.DARK_GREY,
    },
    {
      name: "notification",
      type: "boolean",
      defaultValue: false,
    },
  ],
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/smile.svg",
  description: "Add an icon component to the page",
};
